import React from "react";

export let AccountActivatedPage = function () {
    return (
        <div className="pre-login-page account-activated-page">
            <div className="pre-login-page-content account-activated-content">
                <div className="pre-login-page-header">
                    <img
                        src="/static/images/berger-logo-full-light-gray.svg"
                        className="pre-login-page-logo"
                    />
                </div>
                <div className="account-activated-success-heading">
                    Success!
                </div>
                <div className="account-activated-heading">
                    Your account has been activated.
                </div>
                <div className="account-activated-divider" />
                <div className="account-activated-section-header">
                    FOREMAN
                </div>
                <div className="account-activated-body">
                    If you are a Berger Foreman, download the dispatch app below and login with your credentials.
                </div>
                <div className="account-activated-app-store-badge-row">
                    <a
                        className="account-activated-app-store-badge-link"
                        href="https://apps.apple.com/us/app/berger-dispatch/id6778939729"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            src="/static/images/app-store-badge-white.svg"
                            className="account-activated-app-store-badge"
                        />
                    </a>
                </div>
                <div className="account-activated-divider" />
                <div className="account-activated-section-header">
                    DISPATCH & ADMINS
                </div>
                <div className="account-activated-body">
                    If you are a Berger Dispatcher or Admin, you can access the{" "}
                    <a className="account-activated-desktop-link" href="/login">
                        desktop dispatch web application here
                    </a>.
                </div>
            </div>
        </div>
    );
}
